import { render, staticRenderFns } from "./CadastroSteps.vue?vue&type=template&id=6e48c9e5&scoped=true"
import script from "./CadastroSteps.vue?vue&type=script&lang=js"
export * from "./CadastroSteps.vue?vue&type=script&lang=js"
import style0 from "./CadastroSteps.vue?vue&type=style&index=0&id=6e48c9e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48c9e5",
  null
  
)

export default component.exports